import axios, { AxiosError } from "axios";
import { JwtService } from "../api/JwtService";
import { navigateTo } from "src/utils/NavigationHelper";

export interface ErrorResponse {
  error: string;
  error_description: string;
}

export type ProblemDetail = {
  status: string;
  title: string;
  detail: string;
};

export type ReportHubError = {
    message: string;
    responseData: ProblemDetail;
  }

// create axios instance
export const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = JwtService.get();
    config.headers.Authorization = token ? `Bearer ${token}` : "";

    return config;
});

api.interceptors.response.use(
  (response) => {    
    return response;
  },
  (error: AxiosError) => {
    if (error.config?.url?.includes("/login")) {
      return Promise.reject(error)
    }
    const errorResponse: ErrorResponse = error?.response?.data as ErrorResponse;
    if (error.response?.status === 401) {
      JwtService.remove();         
      const pathname =  window.location.pathname;      
      navigateTo("/login", {state: {referringPathName: pathname.includes("/reports/") ? pathname : undefined}});
    } else if (error.response?.status === 403) {
      navigateTo("/forbidden");
    } else if (      
      error.response?.status === 400 &&
      (errorResponse.error === "login_access_denied" || errorResponse.error === "invalid_grant")
    ) {
      navigateTo("/login");
    } else {      
      const reportHubError: ReportHubError = {
        message: error.message,
        responseData: error?.response?.data as ProblemDetail,
      };
      navigateTo("/error", {
        state: {
          error: reportHubError,
        }, 
        replace: false       
      });
    }
    return Promise.reject(error);
  }
);
